import { render, staticRenderFns } from "./UpdateProgessSend.vue?vue&type=template&id=2dde597c&scoped=true&"
import script from "./UpdateProgessSend.vue?vue&type=script&lang=js&"
export * from "./UpdateProgessSend.vue?vue&type=script&lang=js&"
import style0 from "./UpdateProgessSend.vue?vue&type=style&index=0&id=2dde597c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dde597c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VContainer,VIcon,VTextarea})
